import AlertsTable from '../components/alertsTable/AlertsTable.vue'

export default {
  components: {
    AlertsTable,
  },

  data: () => ({}),

  methods: {},

  created() {},
}
